export default __webpack_public_path__ + "72c5574c4aa91424006cff00f52df532.png";